<template lang="html">

    <div class="cover-popup row-center" v-if="showaviso">

        <span class="close-cover" @click="close"></span>

        <div class="popup">

            <a @click="close" class="close">✕</a>

            <h3 class="title-pop">¿Quieres estar informado de las últimas ofertas de empleo
                dirigidas a tu titulación?</h3>

            <div class="contenedor-check -radio">
                <input type="radio" id="si-ofertas" name="ofertasemail"
                    v-model="ofertasemail" :value="true">
                <label for="si-ofertas">Sí, recibir un email con las ofertas
                    dirigidas a mi titulación</label>
            </div>

            <div class="contenedor-check -radio">
                <input type="radio" id="no-ofertas" name="ofertasemail"
                    v-model="ofertasemail" :value="false">
                <label for="no-ofertas">No, deseo consultarlas únicamente a través de la web</label>
            </div>


            <div class="contenedor-botones row-center">
                <button class="btn" @click="send">Guardar*</button>
            </div>

            <p>*Podrás modificar tus preferencias en cualquier momento desde tu perfil en "MI CV"</p>
        </div>
    </div>


</template>

<script lang="js">

    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'popup-email-ofertas',
        methods:{
            close(){
                this.removeAvisoOfertas();
            },
            send() {
                if(this.ofertasemail){
                    this.clicked = true;
                    this.$validator.validateAll()
                    .then(itsOk => {
                        if (itsOk) {
                            this.setEmailOfertas().then(r => {
                                this.removeAvisoOfertas();
                            })
                        }
                    });
                }else{
                    this.removeAvisoOfertas();
                }
            },
            ...mapActions(['removeAvisoOfertas','setEmailOfertas'])
        },
        data() {
            return {
                ofertasemail : true
            }
        },
        computed : {
            ...mapGetters({
                showaviso : 'getAvisoOfertas'
            })
        }
    }
</script>

<style scoped lang="scss">
.cover-popup .popup .btn {
  margin-top: 0;
}

.contenedor-botones{
    margin-bottom: 20px;
}

.contenedor-check{
    margin-top: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/parts/popup-email-ofertas.vue